import AppSidebar from '@/common/components/AppSidebar'
import { Outlet } from 'react-router-dom'
import { navItems } from '../../constants'
import { LineQuotaWarningDialog } from '@/modules/quota/components/LineQuotaWarningDialog'

export default function AdminLayout() {
	return (
		<>
			<AppSidebar prefixPath="admin" navItems={navItems}>
				<Outlet />
			</AppSidebar>
			<LineQuotaWarningDialog />
		</>
	)
}
